(function () {
	const bookingForm =
		document.querySelector("#booking-form");

	if (!bookingForm) {
		return;
	}

	const firstCalendarTitle =
		document.querySelector("#first-calendar-title");

	const secondCalendarTitle =
		document.querySelector("#second-calendar-title");

	const firstCalendarGrid =
		document.querySelector("#first-calendar-grid");

	const secondCalendarGrid =
		document.querySelector("#second-calendar-grid");

	const previousMonthButton =
		document.querySelector("#previous-month");

	const nextMonthButton =
		document.querySelector("#next-month");

	const arrivalInput =
		document.querySelector("#arrival-date");

	const departureInput =
		document.querySelector("#departure-date");

	const decreaseGuestsButton =
		document.querySelector("#decrease-guests");

	const increaseGuestsButton =
		document.querySelector("#increase-guests");

	const guestCountOutput =
		document.querySelector("#guest-count");

	const guestsInput =
		document.querySelector("#guests-input");

	const summaryArrival =
		document.querySelector("#summary-arrival");

	const summaryDeparture =
		document.querySelector("#summary-departure");

	const summaryNights =
		document.querySelector("#summary-nights");

	const summaryGuests =
		document.querySelector("#summary-guests");

	const summaryNightlyPrice =
		document.querySelector("#summary-nightly-price");

	const summaryTotal =
		document.querySelector("#summary-total");

	const submitButton =
		document.querySelector("#submit-button");

	const formFeedback =
		document.querySelector("#form-feedback");

	const requiredElements = {
		firstCalendarTitle,
		secondCalendarTitle,
		firstCalendarGrid,
		secondCalendarGrid,
		previousMonthButton,
		nextMonthButton,
		arrivalInput,
		departureInput,
		decreaseGuestsButton,
		increaseGuestsButton,
		guestCountOutput,
		guestsInput,
		summaryArrival,
		summaryDeparture,
		summaryNights,
		summaryGuests,
		summaryNightlyPrice,
		summaryTotal,
		submitButton,
		formFeedback
	};

	const missingElements =
		Object.entries(requiredElements)
			.filter(([, element]) => !element)
			.map(([name]) => name);

	if (missingElements.length > 0) {
		console.error(
			"Hiányzó foglalási elemek:",
			missingElements
		);

		return;
	}

	const today = startOfDay(new Date());

	let displayedMonth = new Date(
		today.getFullYear(),
		today.getMonth(),
		1
	);

	let arrivalDate = null;
	let departureDate = null;
	let guests = 2;

	const monthFormatter =
		new Intl.DateTimeFormat(
			"hu-HU",
			{
				year: "numeric",
				month: "long"
			}
		);

	const fullDateFormatter =
		new Intl.DateTimeFormat(
			"hu-HU",
			{
				year: "numeric",
				month: "long",
				day: "numeric"
			}
		);

	const priceFormatter =
		new Intl.NumberFormat(
			"hu-HU",
			{
				style: "currency",
				currency: "HUF",
				maximumFractionDigits: 0
			}
		);

	function startOfDay(date) {
		return new Date(
			date.getFullYear(),
			date.getMonth(),
			date.getDate()
		);
	}

	function datesAreEqual(
		firstDate,
		secondDate
	) {
		return (
			firstDate &&
			secondDate &&
			firstDate.getTime() ===
				secondDate.getTime()
		);
	}

	function isDateInsideRange(date) {
		return (
			arrivalDate &&
			departureDate &&
			date > arrivalDate &&
			date < departureDate
		);
	}

	/*
		Péntek és szombat éjszaka
		számít hétvégi éjszakának.

		0 = vasárnap
		5 = péntek
		6 = szombat
	*/
	function isWeekendNight(date) {
		const dayOfWeek = date.getDay();

		return (
			dayOfWeek === 5 ||
			dayOfWeek === 6
		);
	}

	/*
		Az éjszaka ára annak a dátumnak
		az ára, amelyiken az éjszaka
		elkezdődik.
	*/
	function getNightlyPrice(date) {
		const month = date.getMonth();
		const weekend =
			isWeekendNight(date);

		// Január 1. – április 30.
		if (month >= 0 && month <= 3) {
			return weekend
				? 37000
				: 34000;
		}

		// Május 1. – augusztus 31.
		if (month >= 4 && month <= 7) {
			return weekend
				? 39000
				: 36000;
		}

		// Szeptember 1. – december 31.
		return weekend
			? 38000
			: 35000;
	}

	/*
		Minden éjszaka árát külön
		kiszámítja és árkategóriánként
		csoportosítja.
	*/
	function getBookingPriceDetails() {
		const details = {
			nights: 0,
			weekdayNights: 0,
			weekendNights: 0,
			total: 0,
			breakdown: []
		};

		if (
			!arrivalDate ||
			!departureDate
		) {
			return details;
		}

		const groupedPrices = new Map();
		const currentDate =
			new Date(arrivalDate);

		while (currentDate < departureDate) {
			const weekend =
				isWeekendNight(currentDate);

			const nightlyPrice =
				getNightlyPrice(currentDate);

			const nightType = weekend
				? "weekend"
				: "weekday";

			const groupKey =
				`${nightType}-${nightlyPrice}`;

			if (!groupedPrices.has(groupKey)) {
				groupedPrices.set(
					groupKey,
					{
						type: nightType,
						price: nightlyPrice,
						count: 0
					}
				);
			}

			groupedPrices.get(groupKey).count += 1;

			details.total += nightlyPrice;
			details.nights += 1;

			if (weekend) {
				details.weekendNights += 1;
			} else {
				details.weekdayNights += 1;
			}

			currentDate.setDate(
				currentDate.getDate() + 1
			);
		}

		details.breakdown =
			Array.from(
				groupedPrices.values()
			);

		return details;
	}

	function renderMonth(
		monthDate,
		titleElement,
		gridElement
	) {
		const year =
			monthDate.getFullYear();

		const month =
			monthDate.getMonth();

		titleElement.textContent =
			monthFormatter.format(monthDate);

		gridElement.replaceChildren();

		const firstDayOfMonth =
			new Date(year, month, 1);

		const startingOffset =
			(firstDayOfMonth.getDay() + 6) % 7;

		const numberOfDays =
			new Date(
				year,
				month + 1,
				0
			).getDate();

		for (
			let index = 0;
			index < startingOffset;
			index += 1
		) {
			const emptyCell =
				document.createElement("span");

			emptyCell.className =
				"calendar-day calendar-day--empty";

			emptyCell.setAttribute(
				"aria-hidden",
				"true"
			);

			gridElement.append(emptyCell);
		}

		for (
			let dayNumber = 1;
			dayNumber <= numberOfDays;
			dayNumber += 1
		) {
			const date =
				new Date(
					year,
					month,
					dayNumber
				);

			const dayButton =
				document.createElement("button");

			dayButton.type = "button";
			dayButton.className =
				"calendar-day";

			dayButton.textContent =
				dayNumber;

			dayButton.setAttribute(
				"aria-label",
				fullDateFormatter.format(date)
			);

			dayButton.setAttribute(
				"aria-pressed",
				"false"
			);

			if (
				datesAreEqual(date, today)
			) {
				dayButton.classList.add(
					"calendar-day--today"
				);
			}

			if (
				datesAreEqual(
					date,
					arrivalDate
				)
			) {
				dayButton.classList.add(
					"calendar-day--start"
				);

				dayButton.setAttribute(
					"aria-pressed",
					"true"
				);
			}

			if (
				datesAreEqual(
					date,
					departureDate
				)
			) {
				dayButton.classList.add(
					"calendar-day--end"
				);

				dayButton.setAttribute(
					"aria-pressed",
					"true"
				);
			}

			if (isDateInsideRange(date)) {
				dayButton.classList.add(
					"calendar-day--range"
				);
			}

			if (date < today) {
				dayButton.disabled = true;
			}

			dayButton.addEventListener(
				"click",
				() => {
					selectDate(date);
				}
			);

			gridElement.append(dayButton);
		}
	}

	function renderCalendar() {
		const firstMonth = new Date(
			displayedMonth.getFullYear(),
			displayedMonth.getMonth(),
			1
		);

		const secondMonth = new Date(
			displayedMonth.getFullYear(),
			displayedMonth.getMonth() + 1,
			1
		);

		renderMonth(
			firstMonth,
			firstCalendarTitle,
			firstCalendarGrid
		);

		renderMonth(
			secondMonth,
			secondCalendarTitle,
			secondCalendarGrid
		);

		const currentMonth = new Date(
			today.getFullYear(),
			today.getMonth(),
			1
		);

		previousMonthButton.disabled =
			displayedMonth <= currentMonth;
	}

	function selectDate(date) {
		formFeedback.textContent = "";

		if (
			!arrivalDate ||
			departureDate ||
			date <= arrivalDate
		) {
			arrivalDate =
				startOfDay(date);

			departureDate = null;
		} else {
			departureDate =
				startOfDay(date);
		}

		updateBooking();
		renderCalendar();
	}

	function getNightlyPriceSummary(
		breakdown
	) {
		if (breakdown.length === 0) {
			return "—";
		}

		return breakdown
			.map(item => {
				const nightType =
					item.type === "weekend"
						? "hétvégi"
						: "hétköznapi";

				return (
					`${item.count} ` +
					`${nightType} éjszaka × ` +
					priceFormatter.format(
						item.price
					)
				);
			})
			.join("\n");
	}

	function updateBooking() {
		arrivalInput.value =
			arrivalDate
				? fullDateFormatter.format(
					arrivalDate
				)
				: "";

		departureInput.value =
			departureDate
				? fullDateFormatter.format(
					departureDate
				)
				: "";

		summaryArrival.textContent =
			arrivalDate
				? fullDateFormatter.format(
					arrivalDate
				)
				: "Nincs kiválasztva";

		summaryDeparture.textContent =
			departureDate
				? fullDateFormatter.format(
					departureDate
				)
				: "Nincs kiválasztva";

		const priceDetails =
			getBookingPriceDetails();

		summaryNights.textContent =
			priceDetails.nights
				? `${priceDetails.nights} éjszaka`
				: "—";

		guestCountOutput.value = guests;
		guestCountOutput.textContent = guests;
		guestsInput.value = guests;

		summaryGuests.textContent =
			`${guests} fő`;

		summaryNightlyPrice.textContent =
			getNightlyPriceSummary(
				priceDetails.breakdown
			);

		summaryTotal.textContent =
			priceDetails.nights
				? priceFormatter.format(
					priceDetails.total
				)
				: "—";

		decreaseGuestsButton.disabled =
			guests <= 1;

		increaseGuestsButton.disabled =
			guests >= 6;

		submitButton.disabled =
			!arrivalDate ||
			!departureDate;
	}

	previousMonthButton.addEventListener(
		"click",
		() => {
			displayedMonth = new Date(
				displayedMonth.getFullYear(),
				displayedMonth.getMonth() - 1,
				1
			);

			renderCalendar();
		}
	);

	nextMonthButton.addEventListener(
		"click",
		() => {
			displayedMonth = new Date(
				displayedMonth.getFullYear(),
				displayedMonth.getMonth() + 1,
				1
			);

			renderCalendar();
		}
	);

	decreaseGuestsButton.addEventListener(
		"click",
		() => {
			if (guests > 1) {
				guests -= 1;
				updateBooking();
			}
		}
	);

	increaseGuestsButton.addEventListener(
		"click",
		() => {
			if (guests < 6) {
				guests += 1;
				updateBooking();
			}
		}
	);

	bookingForm.addEventListener(
		"submit",
		event => {
			event.preventDefault();

			if (
				!arrivalDate ||
				!departureDate
			) {
				formFeedback.textContent =
					"Válaszd ki az érkezés és a távozás dátumát.";

				return;
			}

			const priceDetails =
				getBookingPriceDetails();

			formFeedback.textContent =
				`A mintafoglalás sikeresen elkészült. ` +
				`Fizetendő: ${priceFormatter.format(
					priceDetails.total
				)}.`;
		}
	);

	updateBooking();
	renderCalendar();
})();